import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button } from "reactstrap"
import { DefaultColumnFilter } from "components/Common/filters"

const DailyAttendTable = ({
  columns = [], // ✅ safe default
  data = [],    // ✅ safe default
  className,
  pagePerSize,
  isLoading,
  TotalRecords = 0,
}) => {

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups = [], // ✅ prevent undefined
    page = [],
    prepareRow,
    state: { pageSize = 10000 },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageSize: 20000,
        sortBy: [{ desc: true }],
      },
    },
    useGlobalFilter,
    useExpanded,
    usePagination
  )

  const [pageIndex, setPageIndex] = useState(1)

  const generateSortingIndicator = column =>
    column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""

  const safeHeaderCount = headerGroups?.[0]?.headers?.length || 1 // ✅ safeguard

  return (
    <Fragment>
      <div className="table-responsive react-table">
        <Table bordered {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map((headerGroup, hgIndex) => (
              <tr key={hgIndex} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, colIndex) => (
                  <th
                    key={colIndex}
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        width: column.width,
                      },
                    })}
                  >
                    <div className="mb-0">
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {page.length > 0 ? (
            <tbody {...getTableBodyProps()}>
              {page.map((row, rIndex) => {
                prepareRow(row)
                return (
                  <tr key={rIndex} {...row.getRowProps()}>
                    {row.cells.map((cell, cIndex) => (
                      <td
                        key={cIndex}
                        {...cell.getCellProps({
                          style: {
                            minWidth: cell.minWidth,
                            maxWidth: cell.maxWidth,
                            width: cell.width,
                          },
                        })}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                )
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan={safeHeaderCount} className="text-center">
                  {isLoading ? "Loading..." : "No Record Found"}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>
    </Fragment>
  )
}

DailyAttendTable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  TotalRecords: PropTypes.number,
}

export default DailyAttendTable
